import React, { useState, useLayoutEffect } from "react";
import "firebase/auth";
import googleIcon from "../../images/google-icon.svg";
import circle1 from "../../images/circle1.svg";
import circle2 from "../../images/circle2.svg";
import { Redirect } from "react-router-dom";
import img from "../../images/pageImg.png";
import hidden from "../../images/hidden.svg";
import visible from "../../images/visible.svg";
import { useAuth } from "../../contexts/AuthContext";
import NavigationBar from "../NavigationBar";

function useWindowSize() {
  const [size, setSize] = useState([0, 0]);
  useLayoutEffect(() => {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight]);
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);
  return size;
}

function LoginPage({ location }) {
  const { currentUser, login, signup, subscribed, loginWithGoogle } = useAuth();
  const [width, height] = useWindowSize();
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [register, setRegister] = useState(
    location && location.state && location.state.fromFreeUpgrade ? true : false
  );
  const [showPassword, setShowPassword] = useState(false);
  const defaultInputBorder = "#6590ff";

  const redirectHome = () => {
    return <Redirect to="/" />;
  };

  if (currentUser != null && subscribed == 1) {
    return <Redirect to="/dashboard" />;
  }

  if (currentUser != null) {
    return <Redirect to="/" />;
  }

  const resetErrors = (field) => {
    document.getElementById(field + "-error").innerHTML = "";
    document.getElementById(field + "-error").style.display = "nonde";
    document.getElementById(field).style.borderColor = defaultInputBorder;
  };

  return (
    <div>
      <NavigationBar hideLogin />
      <div className="login-page-wrapper">
        <div className="login-image-wrapper">
          <img src={img} />
        </div>
        <div className="login-register-wrapper">
          {register ? (
            <>
              <div className="login-form-title">
                {location && location.state && location.state.fromFreeUpgrade
                  ? "Register to use the Starter version"
                  : "Make your FundMeCo account"}
              </div>
              <form
                id="myForm"
                className="login-form-wrapper"
                onSubmit={(e) => {
                  e.preventDefault();
                  signup(email, password, fullName);
                }}
              >
                <label htmlFor="fullName">Full Name &emsp;</label>
                <input
                  type="text"
                  id="fname"
                  name="fullName"
                  value={fullName}
                  onChange={(e) => {
                    resetErrors("fname");
                    setFullName(e.target.value);
                  }}
                />
                <span id="fname-error" className="field-errors"></span>

                <label htmlFor="email">Email &emsp;</label>
                <input
                  type="text"
                  id="email"
                  name="email"
                  value={email}
                  onChange={(e) => {
                    resetErrors("email");
                    setEmail(e.target.value);
                  }}
                />
                <span id="email-error" className="field-errors"></span>

                <label htmlFor="password">Password &emsp;</label>
                <span
                  style={{
                    display: "flex",
                    width: "100%",
                  }}
                >
                  <input
                    type={showPassword ? "text" : "password"}
                    id="password"
                    name="password"
                    value={password}
                    onChange={(e) => {
                      resetErrors("password");
                      setPassword(e.target.value);
                    }}
                  />
                  <img
                    onClick={() => setShowPassword(!showPassword)}
                    src={showPassword ? visible : hidden}
                    id="password-icon"
                  />
                </span>
                <span id="password-error" className="field-errors"></span>
              </form>
            </>
          ) : (
            <>
              <div className="login-form-title">Log in to your account</div>
              <form
                id="myForm"
                className="login-form-wrapper"
                onSubmit={(e) => {
                  e.preventDefault();
                  login(email, password);
                }}
              >
                <label htmlFor="email">Email &emsp;</label>
                <input
                  type="text"
                  id="email"
                  name="email"
                  value={email}
                  onChange={(e) => {
                    resetErrors("email");
                    setEmail(e.target.value);
                  }}
                />
                <span id="email-error" className="field-errors"></span>
                <label htmlFor="password">Password &emsp;</label>
                <span
                  style={{
                    display: "flex",
                    width: "100%",
                  }}
                >
                  <input
                    type={showPassword ? "text" : "password"}
                    id="password"
                    name="password"
                    value={password}
                    onChange={(e) => {
                      resetErrors("password");
                      setPassword(e.target.value);
                    }}
                  />
                  <img
                    onClick={() => setShowPassword(!showPassword)}
                    src={showPassword ? visible : hidden}
                    id="password-icon"
                  />
                </span>
                <span id="password-error" className="field-errors"></span>
              </form>
            </>
          )}
          {width <= 1200 ? (
            <div
              className="login-toggle-register"
              onClick={() => setRegister(!register)}
            >
              {register
                ? "Already have an account ?"
                : "Don’t have an account?"}
            </div>
          ) : (
            ""
          )}
          <div className="login-button-wrapper">
            <div className="submit-button">
              <input type="submit" form="myForm" value="Submit" />
            </div>
            <div className="googleLoginButtonWrapper">
              <button onClick={() => loginWithGoogle()}>
                <img src={googleIcon} />
                Sign in with Google
              </button>
            </div>
          </div>
          {width > 1200 ? (
            <div
              className="login-toggle-register"
              onClick={() => setRegister(!register)}
            >
              {register
                ? "Already have an account ?"
                : "Don’t have an account?"}
            </div>
          ) : (
            ""
          )}

          <span className="background-circles">
            <img src={circle1} className="circle1" />
            <img src={circle2} className="circle2" />
          </span>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
